import { getCardInstance } from "../selectors/card-instances";
import type { DisbandArmyAction, GameEvent, SetupGameState } from "../types";
import type { TransitionResult } from "./advance-phase";

function eventId(actionSequence: number, ordinal: number): string {
  return `event-${actionSequence}-${ordinal}`;
}

export function applyDisbandArmy(
  state: Readonly<SetupGameState>,
  action: DisbandArmyAction,
  actionSequence: number,
): TransitionResult {
  const instance = getCardInstance(state, action.armyCardInstanceId);
  if (instance === undefined) {
    throw new Error("Validated Army disband unexpectedly lost its card-instance record.");
  }

  const lane = state.lanes[action.laneId];
  const side = lane.players[action.playerId];
  const remainingArmies = side.armies.filter(
    (army) => army.cardInstanceId !== action.armyCardInstanceId,
  );
  const event: GameEvent = {
    type: "army-disbanded",
    eventId: eventId(actionSequence, 0),
    actionSequence,
    playerId: action.playerId,
    laneId: action.laneId,
    armyCardInstanceId: action.armyCardInstanceId,
    cardDefinitionId: instance.cardDefinitionId,
    destination: "discard",
    remainingArmyCardInstanceIds: remainingArmies.map((army) => army.cardInstanceId),
  };

  return {
    state: {
      ...state,
      players: {
        ...state.players,
        [action.playerId]: {
          ...state.players[action.playerId],
          discard: [...state.players[action.playerId].discard, action.armyCardInstanceId],
        },
      },
      lanes: {
        ...state.lanes,
        [action.laneId]: {
          ...lane,
          players: {
            ...lane.players,
            [action.playerId]: {
              ...side,
              armies: remainingArmies,
            },
          },
        },
      },
    },
    events: [event],
  };
}
